<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-29 19:24:40
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-30 18:23:01
-->
<template>
  <el-select
    v-model="selection"
    :filterable="filterable"
    :collapse-tags="collapseTags"
    :multiple="multiple"
    :multiple-limit="multipleLimit"
    :placeholder="placeholder"
    :disabled="disabled"
    clearable
    @change="handleResult"
  >
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item[attrOption.label]"
      :value="item[attrOption.value]"
      :disabled="!!item.disabled"
    >
      {{ item[attrOption.label] }}
    </el-option>
  </el-select>
</template>

<script>
  export default {
    name: 'XSelect',
    inheritAttrs: true,
    model: {
      prop: 'result',
      event: 'handleResult'
    },
    props: {
      options: {
        type: Array,
        default: () => []
      },
      attrOption: {
        type: Object,
        default: () => {
          return { label: 'label', value: 'value' }
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      result: [String, Number, Array],
      collapseTags: {
        type: Boolean,
        default: true
      },
      filterable: {
        type: Boolean,
        default: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      multipleLimit: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        selection: null
      }
    },
    computed: {
      getData() {
        return JSON.stringify(this.result)
      }
    },
    watch: {
      getData(newValue) {
        if (newValue !== JSON.stringify(this.selection)) {
          this.selection = this.result
        }
      }
    },
    mounted() {
      if (this.result) {
        this.selection = this.result
      }
    },
    methods: {
      handleResult() {
        this.$emit('handleResult', this.selection)
      }
    }
  }
</script>
